exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.chat-container__redirect-to-agenda[data-v-0adcd410] {\n  text-decoration: none;\n}\n.chat-container__description--text[data-v-0adcd410] {\n  color: rgba(0, 0, 0, 0.54);\n}\n", "", {"version":3,"sources":["/var/www/appv1.carnet-info-logement.com/src/containers/ticket/ticket-child-chat/styles.scss"],"names":[],"mappings":";AACE;EACE,sBAAqB;CACtB;AACD;EACE,2BAAyB;CAC1B","file":"styles.scss","sourcesContent":[".chat-container {\n  &__redirect-to-agenda {\n    text-decoration: none;\n  }\n  &__description--text {\n    color: rgba(0, 0, 0, .54);\n  }\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0adcd410","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./src/containers/ticket/ticket-child-chat/styles.scss
// module id = npLi
// module chunks = 0